/**
 * The icon registry.
 *
 * Components look up icons here by name rather than importing the whole icon package
 * with a namespace import. A namespace import defeats tree-shaking and pulls every
 * icon in the library into the bundle, which for a studio panel on a slow connection
 * is a real cost rather than a theoretical one.
 *
 * Adding an icon means adding it here, deliberately.
 */
import {
  Activity,
  Archive,
  AudioLines,
  AudioWaveform,
  Bell,
  BellRing,
  CalendarDays,
  ChartColumn,
  ChartLine,
  ChevronLeft,
  ChevronRight,
  Circle,
  CircleAlert,
  Check,
  CircleCheck,
  CircleHelp,
  CircleSlash,
  CircleX,
  Clock,
  Disc3,
  FileAudio,
  Globe,
  Headphones,
  HeartPulse,
  Info,
  Library,
  ListChecks,
  ListMusic,
  KeyRound,
  ListVideo,
  LogOut,
  MessageSquare,
  Megaphone,
  Mic,
  Mic2,
  Music,
  Newspaper,
  Pause,
  Pin,
  Play,
  Phone,
  Podcast,
  Radio,
  Rss,
  Satellite,
  ScrollText,
  Settings,
  Share2,
  ShieldAlert,
  ShieldCheck,
  Siren,
  Sparkles,
  TriangleAlert,
  Upload,
  UserRound,
  Users,
  UsersRound,
  Volume2,
  VolumeX,
  Wifi,
  WifiOff,
  Zap,
} from '@lucide/vue';
import type { Component } from 'vue';

export const ICONS: Readonly<Record<string, Component>> = {
  Activity,
  Archive,
  AudioLines,
  AudioWaveform,
  Bell,
  BellRing,
  CalendarDays,
  ChartColumn,
  ChartLine,
  ChevronLeft,
  ChevronRight,
  Check,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CircleSlash,
  CircleX,
  Clock,
  Disc3,
  FileAudio,
  Globe,
  Headphones,
  HeartPulse,
  Info,
  Library,
  ListChecks,
  ListMusic,
  KeyRound,
  ListVideo,
  LogOut,
  MessageSquare,
  Megaphone,
  Mic,
  Mic2,
  Music,
  Newspaper,
  Pause,
  Pin,
  Play,
  Phone,
  Podcast,
  Radio,
  Rss,
  Satellite,
  ScrollText,
  Settings,
  Share2,
  ShieldAlert,
  ShieldCheck,
  Siren,
  Sparkles,
  TriangleAlert,
  Upload,
  UserRound,
  Users,
  UsersRound,
  Volume2,
  VolumeX,
  Wifi,
  WifiOff,
  Zap,
};

/** Resolve an icon by name, falling back to a neutral mark rather than rendering nothing. */
export function icon(name: string | undefined): Component {
  return (name && ICONS[name]) || Circle;
}
